import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticationService } from '../../authentication/authentication/authentication.service';

@Component({
  selector: 'app-analytics-custom',
  templateUrl: './analytics-custom.component.html',
  styleUrls: ['./analytics-custom.component.scss']
})
export class AnalyticsCustomComponent implements OnInit {
  companyId = this.authService.getCurrentCompanyId();
  
      dashboardUrl!: SafeResourceUrl;
      dashboardProducts!: SafeResourceUrl;
      dashboardWarehouse!: SafeResourceUrl;
          
      iframeError = false;
      iframeError2 = false;
      iframeError3 = false;
  
      constructor(
          private cdRef: ChangeDetectorRef,
          public sanitizer: DomSanitizer,
          private authService : AuthenticationService
      ) {
          
      }
  
      onIframeError() {
          console.error('Error al cargar el iframe');
          this.iframeError = true; // Oculta el iframe si falla
        }
  
      onIframeLoad(index: number) {
          console.log(`Iframe ${index} cargado.`);
      }
  
      ngOnInit() {
          this.companyId = this.authService.getCurrentCompanyId();
  
          setTimeout(() => {
              this.dashboardUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                  `https://lookerstudio.google.com/embed/reporting/7fa869d5-095a-4b0d-8068-9b81f1986a44/page/bXbwE?params=%7B"df1":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
              );
      
              this.dashboardProducts = this.sanitizer.bypassSecurityTrustResourceUrl(
                  `https://lookerstudio.google.com/embed/reporting/ac01bc3d-d050-4ba9-917c-626c3f9bd833/page/6v1wE?params=%7B"df1":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
              );
      
              this.dashboardWarehouse = this.sanitizer.bypassSecurityTrustResourceUrl(
                  `https://lookerstudio.google.com/embed/reporting/b7952936-c84e-409e-a9da-e63546ed89a7/page/tm2wE?params=%7B"df1":"include%25EE%2580%25801%25EE%2580%2580IN%25EE%2580%2580${this.companyId}"%7D&hideToolbar=true`
              );
          }, 500);
  
          this.cdRef.detectChanges();
      }
}
